var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_12506)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2414 13.2965L38.9586 14.6552C39.6155 15.1792 39.9987 15.9734 40 16.8138V37.2414C40 38.7649 38.7649 40 37.2414 40H2.75862C1.23508 40 0 38.7649 0 37.2414V16.8138C0.00131247 15.9734 0.384461 15.1792 1.04138 14.6552L2.75862 13.2965H37.2414Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75879 32.9241V1.37931C2.76106 0.618481 3.37727 0.00227228 4.1381 0H35.8622C36.6231 0.00227228 37.2393 0.618481 37.2415 1.37931V32.2069L2.75879 32.9241Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.069C25.3323 22.069 29.6551 17.7462 29.6551 12.4138C29.6551 7.08137 25.3323 2.75861 19.9999 2.75861C14.6675 2.75861 10.3447 7.08137 10.3447 12.4138C10.3447 17.7462 14.6675 22.069 19.9999 22.069Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9315 17.931C17.5656 17.9317 17.2145 17.7862 16.9564 17.5269L14.1977 14.7683C13.675 14.2271 13.6825 13.3668 14.2145 12.8347C14.7466 12.3027 15.6069 12.2952 16.1481 12.8179L17.9315 14.6007L23.8529 8.68C24.1992 8.32144 24.712 8.17764 25.1943 8.30387C25.6765 8.4301 26.0532 8.80671 26.1794 9.28896C26.3056 9.77121 26.1618 10.284 25.8033 10.6303L18.9067 17.5269C18.6485 17.7862 18.2975 17.9317 17.9315 17.931Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0003 17.1793L40.0003 37.2414C40.0036 38.0243 39.6694 38.7707 39.0831 39.2897L26.0762 29.1793L40.0003 17.1793Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0825 39.2896C38.5779 39.7463 37.9217 39.9994 37.2411 40H2.75837C2.07779 39.9994 1.42162 39.7463 0.916992 39.2896L13.9239 29.1793L19.1446 25.1241C19.6469 24.731 20.3526 24.731 20.8549 25.1241L26.0756 29.1793L39.0825 39.2896Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9242 29.1793L0.917266 39.2897C0.330968 38.7707 -0.00327949 38.0243 2.42621e-05 37.2414L0 17.1793L13.9242 29.1793Z",
    fill: "#F0C419"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_12506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRateIcon);
export default __webpack_public_path__ + "static/media/SuccessRateIcon.e96d27471465c5ad06045fcf7ac27b15.svg";
export { ForwardRef as ReactComponent };